import BaseComponent from './BaseComponent';
import { throttle }  from 'lodash';

class ProductImageThumbnail extends BaseComponent {
  constructor(componentName, autoInit){
    super(componentName);
  }

  init(component) {
    this.addCustomEvents(component);
    const breakpoint = 1200;
    const breakpointUnit = 'px'
    this.pageWidth = window.matchMedia(`(min-width: ${breakpoint}${breakpointUnit})`);
    this.zoomer    = document.getElementsByClassName('zoom')[0];
    this.resized   = false;

    // if (app.device.mobileOrTablet) {
      if(!component.element.classList.contains('thumbnail--video')) {
        const imgBig = component.element.getAttribute('data-gallery-big');
        component.element.setAttribute('src', imgBig);

        this.zoomer = document.getElementsByClassName('zoom')[0];
        this.zoomer.style.backgroundImage = `url(${imgBig})`;
        this.zoomer.nextElementSibling.setAttribute('src', imgBig);
        this.zoomer.parentElement.addEventListener('mousemove', (e) => {
          this.enableZoomImages(e);
        });
      }
    // } else {
    //   this.checkSize(component);
    //   window.addEventListener('resize', _.throttle((e) => {
    //     this.checkSize(component);
    //   }, 500));
    // }
  }

  addCustomEvents(component) {
    const element          = component.element;
    const newImage         = element.getAttribute('data-gallery-big');
    const newVideo         = element.getAttribute('data-embed');
    const featuredImageTag = element.parentElement.parentElement.parentElement.parentElement.getElementsByClassName('img--featured')[0];
    const featuredVideoTag = element.parentElement.parentElement.parentElement.parentElement.getElementsByClassName('iframe-wrapper')[0];

    element.addEventListener('click', (e) => {
      this.updateFeaturedBlock(featuredImageTag, newImage, featuredVideoTag, newVideo);
    });
    element.addEventListener('tap', (e) => {
      this.updateFeaturedBlock(featuredImageTag, newImage, featuredVideoTag, newVideo);
    });
    element.addEventListener('mouseover', (e) => {
      this.updateFeaturedBlock(featuredImageTag, newImage, featuredVideoTag, newVideo);
    });

    // addMultipleListener(element, 'click tap mouseover', this.updateFeaturedBlock(featuredImageTag, newImage));
  }

  checkSize(component){
    if(!this.resized) {
      if (!this.pageWidth.matches) {
        const imgBig = component.element.getAttribute('data-gallery-big');
        component.element.setAttribute('src', imgBig);
      }
      this.resized = true;
    }
  }

  updateFeaturedBlock(featuredImageTag, newImage, featuredVideoTag, newVideo) {
    // VIDEO
    if (!!newVideo) {
      // Check if the current iframe is the same as the one contained in the hovered image
      const iframe = featuredVideoTag.getElementsByTagName('iframe')[0];
      const newIframeParsed = app.parser.parseToHTML(newVideo);
      newIframeParsed.setAttribute('width', '100%');
      newIframeParsed.setAttribute('height', '100%');
      featuredImageTag.parentElement.style.backgroundImage = 'none';

      if (!!iframe) {
        const iframeSrc = iframe.getAttribute('src');
        const newIframeSrc = newIframeParsed.getAttribute('src');
        if (iframeSrc !== newIframeSrc) {
          removeAllChild(featuredVideoTag);
          featuredVideoTag.appendChild(newIframeParsed);
          featuredImageTag.classList.add('hidden');
        }
      } else {
        removeAllChild(featuredVideoTag);
        featuredVideoTag.appendChild(newIframeParsed);
        featuredImageTag.classList.add('hidden');
      }
    // IMAGE
    } else {
      removeAllChild(featuredVideoTag);
      featuredImageTag.classList.remove('hidden');
      featuredImageTag.setAttribute('src', newImage);
      this.zoomer.nextElementSibling.setAttribute('src', newImage);
      this.zoomer.style.backgroundImage = `url(${newImage})`;
    }
  }

  enableZoomImages(e) {
    this.zoomer = document.getElementsByClassName('zoom')[0];
    var offsetX, offsetY, x, y;

    e.offsetX ? offsetX = e.offsetX : offsetX = e.touches ? e.touches[0].pageX : 0;
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches ? e.touches[0].pageX : 0;
    x = offsetX / this.zoomer.offsetWidth  * 100;
    y = offsetY / this.zoomer.offsetHeight * 100;
    this.zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }
}

export default ProductImageThumbnail;
